import React, { useContext, useEffect, useRef, useState } from "react";
import { Chart } from "react-chartjs-2";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { EmployeeworspaceModal } from "./Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../../index.css";
const WorkDashboardnew = () => {
  const chartContainer = useRef(null);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [searchQuery, setSearchQuery] = useState("");

  const [selectedProject, setSelectedProject] = useState(null);
  const [workspacedata, setworkspacedata] = useState([]);
  const [completed, setcompleted] = useState([]);
  const [overdue, setoverdue] = useState([]);
  const [pending, setpending] = useState([]);
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const getWorkspacedata = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
          firmid: user.firm_id,
          ownerid: user.userid,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetYourWorkspace`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setworkspacedata(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const Getcompletedtask = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
          firmid: user.firm_id,
          type: "C",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeTaskStatus`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setcompleted(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const Getoverduetask = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
          firmid: user.firm_id,
          type: "O",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeTaskStatus`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setoverdue(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const getpendingtask = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
          firmid: user.firm_id,
          type: "P",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeTaskStatus`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setpending(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    getWorkspacedata();
    Getcompletedtask();
    Getoverduetask();
    getpendingtask();
  }, []);
  useEffect(() => {
    if (chartContainer && chartContainer.current) {
      const ctx = chartContainer.current.getContext("2d");
      new Chart(ctx, {
        type: "doughnut",
        data: {
          datasets: [
            {
              data: [75, 25],
              backgroundColor: ["green", "grey"],
              borderWidth: 0,
            },
          ],
        },
        options: {
          cutoutPercentage: 70,
          circumference: Math.PI,
          rotation: -Math.PI,
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    }
  }, []);

  const [popoverPosition, setPopoverPosition] = useState({});
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(null);
  const [showAddEmployeeModal, setShowAddEmployeeModal] = useState(false);
  const handleAddEmployeeModalOpen = (workspaceId, projectId) => {
    setSelectedWorkspaceId(workspaceId);
    setSelectedProject(projectId);
    setShowAddEmployeeModal(true);
  };

  const handleAddEmployeeModalClose = () => {
    setShowAddEmployeeModal(false);
  };

  const filteredWorkspaceData = workspacedata.filter((workspace) => {
    // Check if workspace fields match search query
    const workspaceMatches =
      workspace.workspace_name
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      workspace.workspce_desc
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      workspace.project_name
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      workspace.project_ownership
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      workspace.ownername.toLowerCase().includes(searchQuery.toLowerCase());

    // Check if any employee in lettersdata matches search query
    const employeeMatches = workspace.lettersdata.some((employee) =>
      employee.emp_name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return workspaceMatches || employeeMatches;
  });

  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayImageUrl, setOverlayImageUrl] = useState(null);
  const handleImageClick = (imageUrl) => {
    setOverlayImageUrl(imageUrl);
    setShowOverlay(true);
  };
  const handleCloseOverlay = () => {
    setShowOverlay(false);
    setOverlayImageUrl(null);
  };
  return (
    <div className="mt-4" style={{ background: "#fff" }}>
      <div className="row pt-2 m-0 p-0 align-items-center">
        <div className="col d-flex align-items-center">
          <h4 className="mb-0" style={{ lineHeight: "38px" }}>
            Work Dashboard
          </h4>
        </div>

        <div className="col-3 d-flex justify-content-end">
          <div
            className="input-group"
            style={{ height: "38px", width: "100%" }}
          >
            <div className="input-group-prepend">
              <span
                className="input-group-text"
                id="search-addon"
                style={{ height: "100%" }}
              >
                <FaSearch />
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              style={{ height: "100%" }}
              placeholder="Search..."
              aria-label="Search"
              aria-describedby="search-addon"
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>

      <div className="row mt-md-2 pt-md-0">
        <div className=" col">
          <div
            className="card  m-0 p-2 mt-2"
            style={{
              background: "#fff",
              overflowY: "auto",
              height: "33vh",
              overflowX: "hidden",
            }}
          >
            <h5
              className="d-flex justify-content-center"
              style={{ color: "green" }}
            >
              {" "}
              Completed Task
            </h5>
            <table className="table  m-0 p-0 ">
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  background: "#fff",
                }}
              >
                <tr style={{ borderBottom: "1px solid lightgrey" }}>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Due{" "}
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Task
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Deadline{" "}
                  </th>
                </tr>
              </thead>
              <tbody>
                {completed.length === 0 ? (
                  <tr>
                    <td
                      className="text-center align-middle"
                      colSpan={3}
                      style={{ border: "none", background: "#fff" }}
                    >
                      No data found
                    </td>
                  </tr>
                ) : (
                  completed.map((item, index) => (
                    <tr
                      style={{ borderBottom: "1px solid lightgrey" }}
                      key={index}
                    >
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".8rem",
                          background: "#fff",
                        }}
                      >
                        {item.taskname}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".8rem",
                          background: "#fff",
                        }}
                      >
                        {item.task_assignee}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".8rem",
                          background: "#fff",
                        }}
                      >
                        {new Date(item.task_startdate).toLocaleDateString() ||
                          "NA"}
                        <br />
                        {new Date(item.task_enddate).toLocaleDateString() ||
                          "NA"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className=" col m-0 p-0">
          <div
            className="card  m-0 p-2 mt-2"
            style={{
              background: "#fff",
              overflowY: "auto",
              height: "33vh",
              overflowX: "hidden",
            }}
          >
            <h5
              className="d-flex justify-content-center"
              style={{ color: "red" }}
            >
              {" "}
              Overdue Task
            </h5>
            <table className="table  m-0 p-0 ">
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  background: "#fff",
                }}
              >
                <tr style={{ borderBottom: "1px solid lightgrey" }}>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Due{" "}
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Task
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Deadline{" "}
                  </th>
                </tr>
              </thead>
              <tbody>
                {overdue.length === 0 ? (
                  <tr>
                    <td
                      className="text-center align-middle"
                      colSpan={3}
                      style={{
                        border: "none",
                        fontSize: ".8rem",
                        background: "#fff",
                      }}
                    >
                      No data found
                    </td>
                  </tr>
                ) : (
                  overdue.map((item, index) => (
                    <tr
                      style={{ borderBottom: "1px solid lightgrey" }}
                      key={index}
                    >
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".8rem",
                          background: "#fff",
                        }}
                      >
                        {item.taskname}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".8rem",
                          background: "#fff",
                        }}
                      >
                        {item.task_assignee}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".8rem",
                          background: "#fff",
                        }}
                      >
                        {new Date(item.task_startdate).toLocaleDateString() ||
                          "NA"}
                        <br />
                        {new Date(item.task_enddate).toLocaleDateString() ||
                          "NA"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className=" col">
          <div
            className="card  m-0 p-2 mt-2"
            style={{
              background: "#fff",
              overflowY: "auto",
              height: "33vh",
              overflowX: "hidden",
            }}
          >
            <h5
              className="d-flex justify-content-center"
              style={{ color: "#FFA62F" }}
            >
              {" "}
              Pending Task
            </h5>
            <table className="table  m-0 p-0 ">
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  background: "#fff",
                }}
              >
                <tr style={{ borderBottom: "1px solid lightgrey" }}>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Due{" "}
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Task
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Deadline{" "}
                  </th>
                </tr>
              </thead>
              <tbody>
                {pending.length === 0 ? (
                  <tr>
                    <td
                      className="text-center align-middle"
                      colSpan={3}
                      style={{
                        border: "none",
                        fontSize: ".8rem",
                        background: "#fff",
                      }}
                    >
                      No data found
                    </td>
                  </tr>
                ) : (
                  pending.map((item, index) => (
                    <tr
                      style={{ borderBottom: "1px solid lightgrey" }}
                      key={index}
                    >
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".8rem",
                          background: "#fff",
                        }}
                      >
                        {item.taskname}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".8rem",
                          background: "#fff",
                        }}
                      >
                        {item.task_assignee}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".8rem",
                          background: "#fff",
                        }}
                      >
                        {new Date(item.task_startdate).toLocaleDateString() ||
                          "NA"}
                        <br />
                        {new Date(item.task_enddate).toLocaleDateString() ||
                          "NA"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col">
          <div
            className="table-responsive"
            style={{
              borderRadius: ".4em",
              border: "1px solid lightgrey",
            }}
          >
            <table className="table table-bordered m-0 p-0">
              <thead
                style={{
                  top: 0,
                  zIndex: 1,
                  background: "#fff",
                }}
              >
                <tr style={{ borderBottom: "1px solid lightgrey" }}>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Work Space
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Description
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Project
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Team
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Team Size
                  </th>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredWorkspaceData.length === 0 ? (
                  <tr>
                    <td
                      colSpan="5"
                      style={{
                        textAlign: "center",
                        padding: "8px",
                        fontSize: "1rem",
                        fontWeight: "500",
                      }}
                    >
                      No data found
                    </td>
                  </tr>
                ) : (
                  filteredWorkspaceData.reverse().map((item, index) => (
                    <tr
                      style={{ borderBottom: "1px solid lightgrey" }}
                      key={index}
                    >
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".9rem",
                          background: "#fff",
                          fontWeight: "400",
                        }}
                      >
                        {item.workspace_name}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".9rem",
                          background: "#fff",
                          fontWeight: "400",
                        }}
                      >
                        {item.workspce_desc}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          fontSize: ".9rem",
                          background: "#fff",
                          fontWeight: "400",
                        }}
                      >
                        {item.project_name}
                      </td>
                      <td
  className="text-center align-middle p-2"
  style={{
    border: "none",
    background: "#fff",
    fontSize: ".8rem",
    verticalAlign: "middle",
  }}
>
  <div
    className="d-flex flex-wrap justify-content-center align-items-start gap-2"
    style={{ maxWidth: "300px" }}
  >
    {item.lettersdata.map((employee, index) => (
      <div
        key={index}
        className="d-flex flex-column align-items-center"
        style={{
          background: "transparent",
          borderRadius: "0.5rem",
          padding: "0.4rem",
          minWidth: "60px",
          maxWidth: "100px",
        }}
      >
        {employee.image_url ? (
          <img
            src={employee.image_url}
            alt={employee.emp_name}
            onClick={() => handleImageClick(employee.image_url)}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "50%",
              cursor: "pointer",
              border: `2px solid ${item.colourcode}`,
            }}
          />
        ) : (
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: item.colourcode,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
              fontWeight: "bold",
              cursor: "default",
            }}
          >
            {employee.employee_first_letter}
          </div>
        )}
        <span
          className="employee-name text-truncate mt-1"
          style={{
            fontSize: ".7rem",
            maxWidth: "80px",
            textAlign: "center",
            wordBreak: "break-word",
          }}
        >
          {employee.emp_name}
        </span>
      </div>
    ))}
  </div>
</td>


                      <td
                        className="text-center align-middle"
                        style={{
                          border: "none",
                          background: "#fff",
                          fontWeight: "400",
                          fontSize: ".9rem",
                        }}
                      >
                        {item.teamsize}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none", background: "#fff" }}
                      >
                        <Link
                          style={{ fontSize: ".8rem" }}
                          onClick={() =>
                            handleAddEmployeeModalOpen(
                              item.pk_work_id,
                              item.pk_project_id
                            )
                          }
                        >
                          Assign Employee
                        </Link>
                        &nbsp;{" "}
                        <Link to="/Employee/Employeeworkspace">
                          <img
                            onClick={() => {
                              sessionStorage.setItem(
                                "property",
                                JSON.stringify(item)
                              );
                            }}
                            style={{ height: "1.5rem" }}
                            src={require("../../assets/images/arrow.png")}
                          />
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {showOverlay && overlayImageUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={handleCloseOverlay}
        >
          <img
            src={overlayImageUrl}
            alt="Profile Overlay"
            style={{
              width: "40vmin",
              height: "40vmin",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
      )}
      <EmployeeworspaceModal
        isOpen={showAddEmployeeModal}
        onClose={handleAddEmployeeModalClose}
        selectedWorkspaceId={selectedWorkspaceId}
        getWorkspacedata={getWorkspacedata}
        selectedProject={selectedProject}
      />
    </div>
  );
};

export default WorkDashboardnew;
